import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
    selector: 'ce-service-tools-certification-dialog',
    templateUrl: './service-tools-certification-dialog.component.html',
    styleUrls: ['./service-tools-certification-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceToolsCertificationDialogComponent {
    static open(matDialog: MatDialog) {
        return matDialog.open(ServiceToolsCertificationDialogComponent, {
            width: '780px',
            maxHeight: '90vh',
        });
    }

    constructor(private readonly dialogRef: MatDialogRef<ServiceToolsCertificationDialogComponent>) {}

    close() {
        this.dialogRef.close();
    }
}
